import { toggleModal } from '../../../reducers/modalReducer'
import Button from '../../common/Button'
import { useDispatch } from 'react-redux'

const ReferOffer = () => {
    const dispatch = useDispatch()
    return (
        <div
            className="user-info-sidebar 12 check mt12 br8px cp df py1rem px0-5rem aic mt0-5rem fdc bg1 shadow bo45 bss bw1px"
            style={{ width: "100%", paddingLeft: '0.5rem' }}
        >
            <img width={230} src={require('../../../../images/referIcon.svg')} alt='refer' />
            <h3 className='tac c4 fs14px'> We will refund 100% of this client’s subscription </h3>
            <p className='tac c14 fs13px my0-5rem'>For each CFO colleague you introduce to us* ​</p>
            <Button
                style={{
                    width: '120px',
                    height: '34px',
                    padding: '4px',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                }}
                btnType='warning'
                text={"Learn More"}
                onClick={() => dispatch(toggleModal({ open: 'referCfoOffer' }))}
            />
        </div>
    )
}

export default ReferOffer